import type { FC } from 'react';

import type { CustomsDeclarationsSectionType } from '..';
import { CustomDeclaration } from '../../../../components/custom-declaration';
import { ReadOnlyDeclaration } from '../../../../components/custom-declaration/read-only-declaration';
import { useCustomsContext } from '../../../../context/context';
import type { CustomsItem } from '../../../../types';

export const DeclarationsList: FC<CustomsDeclarationsSectionType> = ({ readOnly }) => {
  const { customsItems = [] } = useCustomsContext();

  return customsItems.map((item: CustomsItem, index: number) => {
    const { customsItemId, declarationKey } = item;
    if (readOnly) {
      return <ReadOnlyDeclaration key={customsItemId ?? declarationKey} customItem={item} />;
    }
    return <CustomDeclaration key={customsItemId ?? declarationKey} customItem={item} index={index} />;
  });
};
